import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { useCopy, useLang } from "@/contexts/LanguageContext";

const COPY = {
  en: { h: "Audit Logs", p: "Immutable record of critical platform actions.", cols: ["Time", "Actor", "Role", "Action", "Entity", "IP"], system: "system" },
  hi: { h: "ऑडिट लॉग", p: "मंच की महत्वपूर्ण गतिविधियों का अपरिवर्तनीय रिकॉर्ड।", cols: ["समय", "कर्ता", "भूमिका", "कार्य", "इकाई", "IP"], system: "सिस्टम" },
};

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  const c = useCopy(COPY);
  const { t, tv } = useLang();
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="admin-audit">
      <div><h1 className="text-3xl font-bold text-slate-900 brand-heading">{c.h}</h1><p className="text-slate-600 mt-1 text-sm">{c.p}</p></div>
      <div className="overflow-x-auto table-scroll rounded-lg border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-widest text-slate-500 border-b border-slate-200 bg-slate-50">
            <tr>{c.cols.map((h) => <th key={h} className="py-3 px-4">{h}</th>)}</tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-slate-100">
                <td className="py-3 px-4 text-xs">{new Date(l.timestamp).toLocaleString()}</td>
                <td className="py-3 px-4 font-mono text-xs">{l.actor_id ? l.actor_id.slice(0, 8) : c.system}</td>
                <td className="py-3 px-4 text-xs">{l.role ? t(`role_${l.role}`) : "—"}</td>
                <td className="py-3 px-4">{tv(l.action)}</td>
                <td className="py-3 px-4 text-xs">{tv(l.entity)} {l.entity_id ? `· ${l.entity_id.slice(0, 8)}` : ""}</td>
                <td className="py-3 px-4 text-xs">{l.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
